export default __webpack_public_path__ + "static/media/I0001.bad848e2.png";